import React, { useContext } from 'react';
import First from './First';
import Second from './Second';
import Third from './Third';
import Nav from '../Nav';
import { GlobalContext } from 'App';

const Develop = () => {
    const { isTablet } = useContext(GlobalContext);
    return (
        <section id="employed_develop">
            <First />
            {
                !isTablet &&
                <Nav />
            }
            <Second />
            <Third />
        </section>
    );
}

export default Develop;

